<!-- =========================================================================================
  File Name: TabDescription.vue
  Description: User Edit Description Tab content
========================================================================================== -->

<template>
  <div id="tab-description">
    <div class="vx-row">

      <!-- Col 1 -->
      <div class="vx-col w-full md:w-1/2">
        <vs-textarea rows="8" label="Описание" v-model="partnerLocal.descr" />
      </div>

    </div>

    <!-- Save & Reset Button -->
    <div class="vx-row">
      <div class="vx-col w-full">
        <div class="mt-8 flex flex-wrap items-center justify-end">
          <vs-button class="ml-auto mt-2" icon-pack="feather" icon="icon-chevron-left" :to="{ name: 'apps-partners-view', params:{ partnerId: $route.params.partnerId } }">Назад</vs-button>
          <vs-button class="ml-4 mt-2" icon-pack="feather" icon="icon-rotate-cw" type="border" color="warning" @click="reset_partner">Сброс</vs-button>
          <vs-button class="ml-4 mt-2" icon-pack="feather" icon="icon-save" color="success" @click="save_changes" :disabled="!validateForm">Сохранить</vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      partnerLocal: Object.assign({}, this.$store.getters["partner/getPartner"]),
      partnerOriginal: Object.assign({}, this.$store.state.partner.partner),
    }
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.partnerLocal.company && this.partnerLocal.phone
    }
  },
  methods: {
    save_changes() {
      if(!this.validateForm) return

      this.$store.dispatch("partner/updatePartner", this.partnerLocal)
      .then(() => {
        // this.$router.push({ name:'apps-partners-view', params: { partnerId: this.partnerLocal.partid } });
      })

    },
    reset_partner() {
      this.partnerLocal = Object.assign({}, this.partnerOriginal)
    },
  },
}
</script>
